export const presetColors = [
  '#f44336',
  '#e91e63',
  '#9c27b0',
  '#673ab7',
  '#3f51b5',
  '#2196f3',
  '#03a9f4',
  '#00bcd4',
  '#009688',
  '#4caf50',
  '#8bc34a',
  '#cddc39',
  '#ffeb3b',
  '#ffc107',
  '#ff9800',
  '#ff5722',
  '#795548',
  '#607d8b',
  '#73D8FF',
  '#AEA1FF',
  '#FDA1FF',
  '#cccccc',
  '#F44E3B',
  '#FB9E00',
  '#808900',
  '#194D33',
  '#D33115',
]
